import { render, staticRenderFns } from "./StockReductionList.vue?vue&type=template&id=3339010f&"
import script from "./StockReductionList.vue?vue&type=script&lang=js&"
export * from "./StockReductionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports